import React, { ReactNode } from 'react';
import ResizeIcon from '../../../assets/resize-icon.svg';

interface WidgetFooterProps {
  children?: ReactNode;
  classnames?: string;
}

const WidgetFooter: React.FC<WidgetFooterProps> = ({ children, classnames }) => {
  return (
    <div className={`general-widget-footer ${children && 'footer-top-line'} ${classnames}`}>
      <div className="footer-content-wrapper">{children}</div>
      <img src={ResizeIcon} alt="" className="resize-icon" />
    </div>
  );
};

export default WidgetFooter;
